import "./Heroimagestyle.css";
import React, { useEffect, useState } from 'react';
import Introimg from "../assets/ui1.jpg";
import { Link } from "react-router-dom";

const Heroimage = () => {
  const [showText, setShowText] = useState(false);
  const [text, setText] = useState("");

  useEffect(() => {
    const textArray = ["Solution Developer"];
    let count = 0;
    let currentIndex = 0;
    let currentText = "";

    const timer = setInterval(() => {
      if (count === textArray.length) {
        count = 0;
        currentIndex = 0;
        currentText = "";
      }

      currentText += textArray[count][currentIndex];
      setText(currentText);
      currentIndex++;

      if (currentIndex === textArray[count].length) {
        currentIndex = 0;
        count++;
        setTimeout(() => {
          setText("");
        }, 1000);
      }
    }, 400);

    setTimeout(() => {
      setShowText(true);
    }, 500);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="hero">
      <div className="mask">
        <img className="into-img" src={Introimg} alt="Introimg"/>
      </div>
      <div className="content">
        <p className={showText ? "animated" : ""}>Hi! This is KNORA Tec</p>
        <h1>{text}</h1>
        <div>
          <Link to ="/about" className="btn">About</Link>
          <Link to ="/contact" className="btn btn-light">Contact</Link>
        </div>
      </div>
      
    </div>
  );
};

export default Heroimage;
